import React from "react";
import BarraSupDent from "../../../commons/BarraSupDent";
import Title from "../../../pages/Login/Components/title/title";
import "../Job_in_progress/Job_in_progress.css";
import AddButton from "../../../commons/AddButton";
import NavbarTechnician from "../../../commons/NavbarTechnician";
import { Link } from "react-router-dom";
import firebaseManager from "../../../model/Firebase/FirebaseManager";

class Job_in_progress extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor() {
    super();
    this.showDentInProgress = this.showDentInProgress.bind(this);
    this.state = {
      car_model: "",
      car_brand: "",
      dent_place: "",
      info_location: "",
      price: "",
      timeSelectedRepair: "",
      img1: "",
      img2: "",
      img3: "",
      imgAfterRepair: "",
      notes: "",
      reasonForCalification: "",
    };
    this.showDentInProgress();
  }

  showDentInProgress() {
    firebaseManager.dentInProgress(this.successShowDentInProgress);
  }
  successShowDentInProgress = (dataDent) => {
    this.setState({
      car_model: dataDent.car_model,
      car_brand: dataDent.car_brand,
      dent_place: dataDent.dent_place,
      info_location: dataDent.info_location,
      price: dataDent.price,
      timeSelectedRepair: dataDent.SelectedTimeRepair,
      img1: dataDent.img1,
      img2: dataDent.img2,
      img3: dataDent.img3,
      imgAfterRepair: dataDent.imgAfterRepair,
      notes: dataDent.notes,
      reasonForCalification: dataDent.comments,
    });
  };
  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <b>
          <Title text1="BOOKED" />
        </b>
        <div className="mx-auto mt-3 mb-3 contenedor-request">
          <div className="mx-auto mt-3 mb-3">
            <div className="container card-request mt-3 mb-3">
              <table className="table table-borderless">
                <tbody>
                  <tr>
                    <td>REPAIR PRICE:</td>
                    <td>{this.state.price || "Price to be confirmed"}</td>
                  </tr>
                  <tr>
                    <td>VEHICLE:</td>
                    <td>{this.state.car_brand}</td>
                  </tr>
                  <tr>
                    <td>MODEL:</td>
                    <td>{this.state.car_model}</td>
                  </tr>
                  <tr>
                    <td>DENT LOCATION:</td>
                    <td>{this.state.dent_place}</td>
                  </tr>
                  <tr>
                    <td>ADDRESS:</td>
                    <td>{this.state.info_location}</td>
                  </tr>
                  <tr>
                    <td>TIME AVAILABLE:</td>
                    <td>{this.state.timeSelectedRepair}</td>
                  </tr>
                </tbody>
              </table>

              <div className="text-center mt-4 pb-4">
                <div className="row justify-content-between ml-3 mr-3">
                  <div className="col-xs-4 mb-1">
                    <img
                      width="90px"
                      height="90px"
                      src={this.state.img1}
                      alt="imagen"
                      className="mx-auto"
                    />
                  </div>
                  <div className="col-xs-4 mb-1">
                    <img
                      width="90px"
                      height="90px"
                      src={this.state.img2}
                      alt="imagen"
                      className="mx-auto"
                    />
                  </div>
                  <div className="col-xs-4 mb-1">
                    <img
                      width="90px"
                      height="90px"
                      src={this.state.img3}
                      alt="imagen"
                      className="mx-auto"
                    />
                  </div>
                </div>
              </div>
              <div className="row pb-3 pt-3">
                <table className="table table-borderless">
                  <tbody>
                    <tr>
                      <td>NOTES:</td>
                      <td>{this.state.notes || "No notes"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <Link to="/job_completed">
          <AddButton text="COMPLETE" />
        </Link>
        <div className="text-center mb-5">
          <Link to="/cancelJob">
            <button className="btn cancelButton mb-5">CANCEL JOB</button>
          </Link>
        </div>

        <NavbarTechnician />
      </React.Fragment>
    );
  }
}
export default Job_in_progress;
